import React from 'react';

const VideoWrapper = React.memo(function VideoWrapper({
  children,
  isVideoLoaded,
  layout,
  onVideoClick,
}: {
  children: React.ReactNode;
  isVideoLoaded: boolean;
  layout?: 'default' | 'chat';
  onVideoClick?: () => void;
}) {
  return (
    <div
      className={`video-wrapper-container ${!isVideoLoaded ? 'loading-video' : ''}${layout === 'chat' ? ' minimized' : ''}`}
      onClick={onVideoClick}
      onKeyDown={onVideoClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') onVideoClick(); } : undefined}
      role={onVideoClick ? 'button' : undefined}
      tabIndex={onVideoClick ? 0 : undefined}
    >
      <div className="video-wrapper">
        <div className="iphone-x">{children}</div>
      </div>
    </div>
  );
});

export default VideoWrapper;
